const r = (t) => {
  const e = t.currentTime(), n = t.duration();
  return e && n ? Math.round(e / n * 100) : null;
};
export {
  r as getVideoPercentage
};
